import * as React from 'react';
import { cn } from '@/utils/cn';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  indeterminate?: boolean;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, indeterminate, ...props }, ref) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const combinedRef = React.useCallback(
      (node: HTMLInputElement) => {
        inputRef.current = node;
        if (typeof ref === 'function') {
          ref(node);
        } else if (ref) {
          ref.current = node;
        }
      },
      [ref]
    );

    React.useEffect(() => {
      if (inputRef.current) {
        inputRef.current.indeterminate = indeterminate || false;
      }
    }, [indeterminate]);

    return (
      <label className="flex items-center gap-2 cursor-pointer group">
        <input
          type="checkbox"
          ref={combinedRef}
          className={cn(
            'w-4 h-4 rounded border-gray-600 bg-[#0f172a] text-[#2d3e9f]',
            'focus:ring-2 focus:ring-[#2d3e9f] focus:ring-offset-0',
            'checked:bg-[#2d3e9f] checked:border-[#2d3e9f]',
            'disabled:cursor-not-allowed disabled:opacity-50',
            'transition-colors cursor-pointer',
            className
          )}
          {...props}
        />
        {label && (
          <span className="text-sm text-white group-hover:text-gray-200 transition-colors">
            {label}
          </span>
        )}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export { Checkbox };

